/*
 * Cal.com booking links.
 *
 * HOW TO TURN THE CALENDAR ON
 * ---------------------------
 * Paste the Cal.com event link into the matching constant below, in the short
 * "username/event-slug" form that Cal.com shows on the event type page — for
 * example "jane-doe/free-ai-call" (no https://, no cal.com/ prefix).
 *
 * While a constant is an empty string, /book renders the request form instead
 * and the lead still reaches us. Do not guess a username: an embed pointing at
 * a calendar that does not exist looks broken and loses the lead.
 */

export const CAL_FREE_CALL_LINK = "";
export const CAL_WORKING_SESSION_LINK = "";

export type BookingOptionId = "free-call" | "working-session";

export interface BookingOption {
  id: BookingOptionId;
  name: string;
  duration: string;
  price: string;
  description: string;
  calLink: string;
}

export const BOOKING_OPTIONS: readonly BookingOption[] = [
  {
    id: "free-call",
    name: "Free AI Call",
    duration: "20 minutes",
    price: "$0",
    description:
      "An honest read on whether AI helps your business, and where it would start.",
    calLink: CAL_FREE_CALL_LINK,
  },
  {
    id: "working-session",
    name: "Working Session",
    duration: "60 minutes",
    price: "$300",
    description:
      "A focused paid session on a specific problem — architecture, tool selection, a second opinion on a build.",
    calLink: CAL_WORKING_SESSION_LINK,
  },
] as const;
